import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import { ModalAllder } from "layouts/ModalAllder";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { NumberFormat } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { allBranch } from "../../redux/handlers/manage/allBranch.handler";
import { allBranchByID } from "../../redux/handlers/manage/allBranchByID.handler";
import { allPosition } from "../../redux/handlers/manage/allPosition.handler";
import { allPositionByID } from "../../redux/handlers/manage/allPositionByID.handler";
import { allAdpoint } from "../../redux/handlers/manage/allAdpoint.handler";
import { allAdpointByID } from "../../redux/handlers/manage/allAdpointByID.handler";
import { createBranch, clearcreateBranch } from "../../redux/handlers/manage/createBranch.handler";
import { updateBranch, clearupdateBranch } from "../../redux/handlers/manage/updateBranch.handler";
import { deleteBranch, cleardeleteBranch } from "../../redux/handlers/manage/deleteBranch.handler";
import { createPosition, clearcreatePosition } from "../../redux/handlers/manage/createPosition.handler";
import { updatePosition, clearupdatePosition } from "../../redux/handlers/manage/updatePosition.handler";
import { deletePosition, cleardeletePosition } from "../../redux/handlers/manage/deletePosition.handler";
import { createAdpoint, clearcreateAdpoint } from "../../redux/handlers/manage/createAdpoint.handler";
import { updateAdpoint, clearupdateAdpoint } from "../../redux/handlers/manage/updateAdpoint.handler";
import { deleteAdpoint, cleardeleteAdpoint } from "../../redux/handlers/manage/deleteAdpoint.handler";
export function Branch() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), textName = _useState6[0], setTextName = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState7[0], setModal = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState8[0], setModalDel = _useState8[1];
    var allBranchReducer = useAppSelector(function(state) {
        return state.allBranchReducer;
    });
    useEffect(function() {
        dispatch(allBranch({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(allBranchReducer.isFetching);
        if (allBranchReducer.data) {
            var data = allBranchReducer.data.data;
            setRowData(data);
            setFilteredItems(data);
        }
    }, [
        allBranchReducer
    ]);
    useEffect(function() {
        if (filterText) {
            setRowData(filteredItems.filter(function(item) {
                return item.set_branch_name && item.set_branch_name.toLowerCase().includes(filterText.toLowerCase());
            }));
        } else {
            setRowData(filteredItems);
        }
    }, [
        rowData,
        filterText
    ]);
    var columns = [
        {
            name: "ชื่อสาขา",
            selector: function(row) {
                return row.set_branch_name;
            },
            center: "true"
        },
        {
            name: "หมายเหตุ",
            selector: function(row) {
                return row.set_branch_remark ? row.set_branch_remark : "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_branch_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.set_branch_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.set_branch_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_branch_id;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            to: "/branch/manage/" + row.set_branch_id,
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(VisibilityIcon, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#FFF1DD",
                                    color: "#FFA319",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editBranch",
                                        data: {
                                            id: row.set_branch_id,
                                            name: row.set_branch_name,
                                            remark: row.set_branch_remark,
                                            status: row.set_branch_status
                                        }
                                    });
                                });
                                setmodelText("แก้ไขสาขา");
                                setTextName("ชื่อสาขา");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            // to={"/branch/manage/" + row.set_branch_id}
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deleteBranch",
                                        data: {
                                            id: row.set_branch_id,
                                            name: row.set_branch_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบสาขา");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการสาขา"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "จัดการสาขา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 7,
                                        children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                            data: rowData,
                                            filename: "จัดการสาขา"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 8,
                                        lg: 5,
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "horizontal",
                                            children: [
                                                /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control",
                                                    placeholder: "ค้นหาสาขา",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "btn btn-dg ml-2 w-[250px] fs-14",
                                                    onClick: function() {
                                                        setModal(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true,
                                                                typeData: "createBranch",
                                                                data: null
                                                            });
                                                        });
                                                        setmodelText("เพิ่มสาขา");
                                                        setTextName("ชื่อสาขา");
                                                    },
                                                    children: "เพิ่มสาขา"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(BranchModel, {
                    setModal: setModal,
                    modal: modal,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    textName: textName
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function BranchManage() {
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var businessID = null;
    var memID = null;
    var accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
        try {
            var base64Url = accessToken.split(".")[1];
            if (base64Url) {
                try {
                    var _payload_member, _payload_member1;
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var payload = JSON.parse(atob(base64));
                    businessID = parseInt((_payload_member = payload.member) === null || _payload_member === void 0 ? void 0 : _payload_member.bus_business_id) || null;
                    memID = parseInt((_payload_member1 = payload.member) === null || _payload_member1 === void 0 ? void 0 : _payload_member1.mb_mem_id) || null;
                } catch (error) {
                    console.error("Failed to decode access token payload:", error);
                }
            } else {
                console.error("Invalid access token format.");
            }
        } catch (error) {
            console.error("Invalid access token:", error);
        }
    }
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState({}), 2), formdata = _useState[0], setFormdata = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), dataPosition = _useState1[0], setDataPosition = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), dataAdpoint = _useState2[0], setDataAdpoint = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), formdisabled = _useState3[0], setFormdisabled = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), type = _useState4[0], setType = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), modelText = _useState5[0], setmodelText = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), modalsuccess = _useState6[0], setModalsuccess = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), textsuccess = _useState7[0], setTextsuccess = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), textName = _useState8[0], setTextName = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 400,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState9[0], setModal = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 300,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState10[0], setModalDel = _useState10[1];
    var schema = yup.object().shape({});
    var allBranchByIDReducer = useAppSelector(function(state) {
        return state.allBranchByIDReducer;
    });
    var allPositionReducer = useAppSelector(function(state) {
        return state.allPositionReducer;
    });
    var allPositionByIDReducer = useAppSelector(function(state) {
        return state.allPositionByIDReducer;
    });
    var allAdpointReducer = useAppSelector(function(state) {
        return state.allAdpointReducer;
    });
    var allAdpointByIDReducer = useAppSelector(function(state) {
        return state.allAdpointByIDReducer;
    });
    useEffect(function() {
        if (dataID) {
            dispatch(allBranchByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(allPosition(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            dispatch(allAdpoint(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, []);
    useEffect(function() {
        setIsLoading(allBranchByIDReducer.isFetching || allPositionReducer.isFetching || allAdpointReducer.isFetching);
        if (dataID) {
            if (allBranchByIDReducer.data) {
                var dataBranch = allBranchByIDReducer.data.data;
                setFormdata(dataBranch);
                setType(dataBranch.set_branch_status);
            }
            if (allPositionReducer.data) {
                setDataPosition(allPositionReducer.data.data);
            }
            if (allAdpointReducer.data) {
                setDataAdpoint(allAdpointReducer.data.data);
            }
        }
    }, [
        allBranchByIDReducer,
        allPositionReducer,
        allAdpointReducer
    ]);
    var columnsPosition = [
        {
            name: "ชื่อตำแหน่งวางสินค้า",
            selector: function(row) {
                return row.set_position_name;
            },
            center: "true"
        },
        {
            name: "ราคามาตรฐาน",
            selector: function(row) {
                return NumberFormat(row.set_position_cost ? row.set_position_cost : 0, 2);
            },
            center: "true"
        },
        {
            name: "หมายเหตุ",
            selector: function(row) {
                return row.set_position_remark ? row.set_position_remark : "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_position_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.set_position_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.set_position_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_position_id;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editPosition",
                                        data: {
                                            id: row.set_position_id,
                                            name: row.set_position_name,
                                            cost: row.set_position_cost,
                                            remark: row.set_position_remark,
                                            status: row.set_position_status
                                        }
                                    });
                                });
                                setmodelText("แก้ไขสถานที่วางสินค้า");
                                setTextName("ชื่อตำแหน่งวางสินค้า");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deletePosition",
                                        data: {
                                            id: row.set_position_id,
                                            name: row.set_position_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบสถานที่วางสินค้า");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        })
                    ]
                });
            }
        }
    ];
    var columnsAdpoint = [
        {
            name: "ชื่อตำแหน่งวางสินค้า",
            selector: function(row) {
                return row.set_adpoint_name;
            },
            center: "true"
        },
        {
            name: "ราคามาตรฐาน",
            selector: function(row) {
                return NumberFormat(row.set_adpoint_cost ? row.set_adpoint_cost : 0, 2);
            },
            center: "true"
        },
        {
            name: "หมายเหตุ",
            selector: function(row) {
                return row.set_adpoint_remark ? row.set_adpoint_remark : "-";
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.set_adpoint_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.set_adpoint_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ใช้งาน"
                }) || row.set_adpoint_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่ใช้งาน"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.set_adpoint_id;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "editAdpoint",
                                        data: {
                                            id: row.set_adpoint_id,
                                            name: row.set_adpoint_name,
                                            cost: row.set_adpoint_cost,
                                            remark: row.set_adpoint_remark,
                                            status: row.set_adpoint_status
                                        }
                                    });
                                });
                                setmodelText("แก้ไขตำแหน่งวางโฆษณา");
                                setTextName("ชื่อตำแหน่งวางโฆษณา");
                            },
                            style: {
                                marginRight: 5
                            },
                            children: /*#__PURE__*/ _jsx(EditIcon, {
                                style: {
                                    color: "#797A7A",
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "#E9E9E9",
                                    padding: 5
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            onClick: function() {
                                setModalDel(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true,
                                        typeData: "deleteAdpoint",
                                        data: {
                                            id: row.set_adpoint_id,
                                            name: row.set_adpoint_name
                                        }
                                    });
                                });
                                setmodelText("ยืนยันลบตำแหน่งวางโฆษณา");
                            },
                            style: {
                                marginRight: 3
                            },
                            children: /*#__PURE__*/ _jsx(DeleteOutline, {
                                style: {
                                    fontSize: 30,
                                    borderRadius: 40,
                                    background: "rgb(255, 227, 227)",
                                    color: "#FF0000",
                                    padding: 5
                                }
                            })
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการสาขา"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "จัดการสาขา"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(Form, {
                            noValidate: true,
                            onSubmit: function(e) {
                                e.preventDefault();
                                handleSubmit();
                            },
                            children: /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    alignContent: "flex-start",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "tc-8 py-2 fs-18 fw-bold px-3",
                                                        children: "จัดการสาขา"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "pt-3 px-3 pagezoom",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ชื่อสาขา"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "set_branch_name",
                                                                            placeholder: "ชื่อสาขา",
                                                                            value: values.set_branch_name,
                                                                            onChange: function(e) {
                                                                                handleChange(e);
                                                                            },
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-6 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "set_branch_remark",
                                                                            placeholder: "หมายเหตุ",
                                                                            value: values.set_branch_remark,
                                                                            onChange: function(e) {
                                                                                handleChange(e);
                                                                            },
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-1 col-md-12",
                                                                children: /*#__PURE__*/ _jsx(Form.Label, {
                                                                    className: "mb-2 mt-3 tc-10",
                                                                    children: "สถานะ"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-10 col-md-12",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "mt-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                                            inline: true,
                                                                            type: "radio",
                                                                            id: "p-radio-1",
                                                                            label: "เปิดใช้งาน",
                                                                            checked: type == 1 ? true : false,
                                                                            className: "form-check-st-2 tc-7 mt-0",
                                                                            disabled: true,
                                                                            onChange: function() {
                                                                                setType(1);
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                                            inline: true,
                                                                            type: "radio",
                                                                            id: "p-radio-2",
                                                                            label: "ปิดใช้งาน",
                                                                            checked: type == 2 ? true : false,
                                                                            disabled: true,
                                                                            className: "form-check-st-2 tc-7 mt-0",
                                                                            onChange: function() {
                                                                                setType(2);
                                                                            }
                                                                        })
                                                                    ]
                                                                }, "p-radio")
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    alignContent: "flex-start",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8 py-2 fs-18 fw-bold px-3",
                                                            children: "จัดการตำแหน่งวางสินค้า"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "button",
                                                            onClick: function() {
                                                                setModal(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        open: true,
                                                                        typeData: "createPosition",
                                                                        data: null
                                                                    });
                                                                });
                                                                setmodelText("สร้างสถานที่วางสินค้า");
                                                                setTextName("ชื่อตำแหน่งวางสินค้า");
                                                            },
                                                            className: "btn btn-dg fs-14 mb-3",
                                                            children: "เพิ่มตำแหน่งวางสินค้า"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(DataTableLayout, {
                                                    item: dataPosition,
                                                    columns: columnsPosition,
                                                    isSelectRows: false,
                                                    PerPage: 10
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "card-body px-xl-3",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "space-between",
                                                    alignContent: "flex-end",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "tc-8 py-2 fs-18 fw-bold px-3",
                                                            children: "จัดการตำแหน่งวางโฆษณา"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "button",
                                                            onClick: function() {
                                                                setModal(function(prev) {
                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                        open: true,
                                                                        data: null,
                                                                        typeData: "createAdpoint"
                                                                    });
                                                                });
                                                                setmodelText("สร้างตำแหน่งวางโฆษณา");
                                                                setTextName("ชื่อตำแหน่งวางโฆษณา");
                                                            },
                                                            className: "btn btn-dg fs-14 mb-3",
                                                            children: "เพิ่มตำแหน่งวางโฆษณา"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(DataTableLayout, {
                                                    item: dataAdpoint,
                                                    columns: columnsAdpoint,
                                                    isSelectRows: false,
                                                    PerPage: 10
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    });
                }
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(BranchModel, {
                    setModal: setModal,
                    modal: modal,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    dataID: dataID,
                    textName: textName
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: modelText,
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    dataID: dataID
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function BranchModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID, textName = param.textName;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(""), 2), name = _useState[0], setName = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), remark = _useState1[0], setRemark = _useState1[1];
    var _useState2 = _sliced_to_array(useState(1), 2), type = _useState2[0], setType = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), cost = _useState3[0], setCost = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), id = _useState4[0], setId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), textErr = _useState5[0], setTextErr = _useState5[1];
    var createBranchReducer = useAppSelector(function(state) {
        return state.createBranchReducer;
    });
    var updateBranchReducer = useAppSelector(function(state) {
        return state.updateBranchReducer;
    });
    var createPositionReducer = useAppSelector(function(state) {
        return state.createPositionReducer;
    });
    var updatePositionReducer = useAppSelector(function(state) {
        return state.updatePositionReducer;
    });
    var createAdpointReducer = useAppSelector(function(state) {
        return state.createAdpointReducer;
    });
    var updateAdpointReducer = useAppSelector(function(state) {
        return state.updateAdpointReducer;
    });
    useEffect(function() {
        if (modal.data == null) {
            setName("");
            setRemark("");
            setType(1);
            setId(0);
            setCost(0);
            setTextErr("");
        }
        if (modal.data != null) {
            var vul = modal.data;
            setName(vul.name);
            setRemark(vul.remark);
            setType(vul.status);
            setCost(vul.cost);
            setId(vul.id);
            setTextErr("");
        }
    }, [
        modal.data,
        modal.open
    ]);
    useEffect(function() {
        setIsLoading(createBranchReducer.isFetching || updateBranchReducer.isFetching || createPositionReducer.isFetching || updatePositionReducer.isFetching || createAdpointReducer.isFetching || updateAdpointReducer.isFetching);
        if (createBranchReducer.data && !createBranchReducer.isError) {
            setTextsuccess("สร้างสถานที่สำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateBranch());
            dispatch(allBranch({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setRemark("");
            setType(1);
            setId(0);
            setTextErr("");
        }
        if (updateBranchReducer.data && !updateBranchReducer.isError) {
            setTextsuccess("แก้ไขสาขาสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateBranch());
            dispatch(allBranch({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setRemark("");
            setType(1);
            setId(0);
            setTextErr("");
        }
        if (createPositionReducer.data && !createPositionReducer.isError) {
            setTextsuccess("สร้างตำแหน่งวางสินค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreatePosition());
            dispatch(allPosition(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setRemark("");
            setType(1);
            setCost(0);
            setId(0);
            setTextErr("");
        }
        if (updatePositionReducer.data && !updatePositionReducer.isError) {
            setTextsuccess("แก้ไขตำแหน่งวางสินค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdatePosition());
            dispatch(allPosition(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setRemark("");
            setType(1);
            setCost(0);
            setId(0);
            setTextErr("");
        }
        if (createAdpointReducer.data && !createAdpointReducer.isError) {
            setTextsuccess("สร้างตำแหน่งวางโฆษณาสำเร็จ");
            setModalsuccess(true);
            dispatch(clearcreateAdpoint());
            dispatch(allAdpoint(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setRemark("");
            setType(1);
            setCost(0);
            setId(0);
            setTextErr("");
        }
        if (updateAdpointReducer.data && !updateAdpointReducer.isError) {
            setTextsuccess("แก้ไขตำแหน่งวางโฆษณาสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateAdpoint());
            dispatch(allAdpoint(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setName("");
            setRemark("");
            setType(1);
            setCost(0);
            setId(0);
            setTextErr("");
        }
    }, [
        createBranchReducer,
        updateBranchReducer,
        createPositionReducer,
        updatePositionReducer,
        createAdpointReducer,
        updateAdpointReducer
    ]);
    var onClickModel = function() {
        if (modal.typeData == "createBranch") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อสาขา");
            } else {
                var data = {
                    set_branch_name: name,
                    set_branch_status: type,
                    set_branch_remark: remark
                };
                dispatch(createBranch(data, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "editBranch") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อสาขา");
            } else {
                var data1 = {
                    set_branch_id: id,
                    set_branch_name: name,
                    set_branch_status: type,
                    set_branch_remark: remark
                };
                dispatch(updateBranch(data1, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "createPosition") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อตำแหน่งวางสินค้า");
            } else {
                var data2 = {
                    set_position_branchid: parseInt(dataID),
                    set_position_name: name,
                    set_position_status: type,
                    set_position_cost: parseFloat(cost),
                    set_position_remark: remark
                };
                dispatch(createPosition(data2, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "editPosition") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อตำแหน่งวางสินค้า");
            } else {
                var data3 = {
                    set_position_id: id,
                    set_position_branchid: parseInt(dataID),
                    set_position_name: name,
                    set_position_status: type,
                    set_position_cost: parseFloat(cost),
                    set_position_remark: remark
                };
                dispatch(updatePosition(data3, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "createAdpoint") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อตำแหน่งวางโฆษณา");
            } else {
                var data4 = {
                    set_adpoint_branchid: parseInt(dataID),
                    set_adpoint_name: name,
                    set_adpoint_status: type,
                    set_adpoint_cost: parseFloat(cost),
                    set_adpoint_remark: remark
                };
                dispatch(createAdpoint(data4, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        } else if (modal.typeData == "editAdpoint") {
            if (!name) {
                setTextErr("กรุณากรอกชื่อตำแหน่งวางโฆษณา");
            } else {
                var data5 = {
                    set_adpoint_id: id,
                    set_adpoint_branchid: parseInt(dataID),
                    set_adpoint_name: name,
                    set_adpoint_status: type,
                    set_adpoint_cost: parseFloat(cost),
                    set_adpoint_remark: remark
                };
                dispatch(updateAdpoint(data5, {
                    modalObj: modalObj,
                    setModalObj: setModalObj
                }));
            }
        }
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "row gx-xl-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsxs(Form.Label, {
                                className: "mb-1",
                                children: [
                                    textName,
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-danger",
                                        children: " *"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control ".concat(name ? "" : !name ? "is-invalid" : ""),
                                placeholder: textName,
                                value: name,
                                onChange: function(e) {
                                    setName(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-8",
                                children: textErr
                            })
                        ]
                    })
                }),
                modal.typeData == "createBranch" || modal.typeData == "editBranch" ? "" : /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Label, {
                                className: "mb-1",
                                children: "ราคามาตรฐาน"
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control",
                                placeholder: "ราคามาตรฐาน",
                                value: cost,
                                onChange: function(e) {
                                    setCost(e.target.value);
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                        className: "mb-2 form-st-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsx(Form.Label, {
                                className: "mb-1",
                                children: "หมายเหตุ"
                            }),
                            /*#__PURE__*/ _jsx(Form.Control, {
                                type: "text",
                                className: "form-control",
                                placeholder: "หมายเหตุ",
                                value: remark,
                                onChange: function(e) {
                                    setRemark(e.target.value);
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsx(Form.Label, {
                        className: "mb-2  tc-10",
                        children: "สถานะ"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-1",
                                label: "เปิดใช้งาน",
                                checked: type == 1 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setType(1);
                                }
                            }),
                            /*#__PURE__*/ _jsx(Form.Check, {
                                inline: true,
                                type: "radio",
                                id: "p-radio-2",
                                label: "ปิดใช้งาน",
                                checked: type == 2 ? true : false,
                                className: "form-check-st-2 tc-7 mt-0",
                                onChange: function() {
                                    setType(2);
                                }
                            })
                        ]
                    }, "p-radio")
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-end",
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 me-3 btn py-2 px-3 mt-4",
                                onClick: function() {
                                    return setModal(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            open: false
                                        });
                                    });
                                },
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "mt-4 btn btn-dg w-400",
                                onClick: function(e) {
                                    onClickModel();
                                },
                                children: "บันทึก"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var _modal_data;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(0), 2), id = _useState[0], setId = _useState[1];
    var deleteBranchReducer = useAppSelector(function(state) {
        return state.deleteBranchReducer;
    });
    var deletePositionReducer = useAppSelector(function(state) {
        return state.deletePositionReducer;
    });
    var deleteAdpointReducer = useAppSelector(function(state) {
        return state.deleteAdpointReducer;
    });
    useEffect(function() {
        setIsLoading(deleteBranchReducer.isFetching || deletePositionReducer.isFetching || deleteAdpointReducer.isFetching);
        if (deleteBranchReducer.data && !deleteBranchReducer.isError) {
            setTextsuccess("ลบสาขาสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteBranch());
            dispatch(allBranch({
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
        if (deletePositionReducer.data && !deletePositionReducer.isError) {
            setTextsuccess("ลบสถานที่วางสินค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeletePosition());
            dispatch(allPosition(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
        if (deleteAdpointReducer.data && !deleteAdpointReducer.isError) {
            setTextsuccess("ลบสถานที่วางสินค้าสำเร็จ");
            setModalsuccess(true);
            dispatch(cleardeleteAdpoint());
            dispatch(allAdpoint(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        deleteBranchReducer,
        deletePositionReducer,
        deleteAdpointReducer
    ]);
    useEffect(function() {
        if (modal.data != null) {
            var vul = modal.data;
            setId(vul.id);
        }
    }, [
        modal.data,
        modal.open
    ]);
    var onClickModel = function() {
        if (modal.typeData == "deleteBranch") {
            var data = {
                set_branch_id: id
            };
            dispatch(deleteBranch(data, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "deletePosition") {
            var data1 = {
                set_position_id: id
            };
            dispatch(deletePosition(data1, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modal.typeData == "deleteAdpoint") {
            var data2 = {
                set_adpoint_id: id
            };
            dispatch(deleteAdpoint(data2, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "px-3 py-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการลบข้อมูลนี้"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 my-6",
                    children: (_modal_data = modal.data) === null || _modal_data === void 0 ? void 0 : _modal_data.name
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
